import RIGENERAEVO from "../assets/cardsProductos/RIGENERA EVO.webp";
import pbserumSMARTKER from "../assets/cardsProductos/SMARTKER.jpg";
import pbserumHA from "../assets/cardsProductos/pbserum HA.webp";
import pbserumHATotalCorrector from "../assets/cardsProductos/pbserum HA Total Corrector.webp";
import pbserumHAPartialCorrector from "../assets/cardsProductos/pbserum HA Partial Corrector.webp";
import ADVALight from "../assets/cardsProductos/ADVALight.webp";
import BodyStimdeBrera from "../assets/cardsProductos/Body Stim de Brera.webp";
import CO2Lift from "../assets/cardsProductos/CO2Lift®.webp";
import Emerald from "../assets/cardsProductos/Emerald.webp";
import ColagenoFINE from "../assets/cardsProductos/Colágeno FINE.webp";
import FX405 from "../assets/cardsProductos/FX 405.webp";
import GVL from "../assets/cardsProductos/GVL.webp";
import GOURI from "../assets/cardsProductos/GOURI.webp";
import HyperPulse from "../assets/cardsProductos/Hyper Pulse.webp";
import JOVENA from "../assets/cardsProductos/JOVENA.webp";
import JALUPRO from "../assets/cardsProductos/JALUPRO®.webp";
import Lavieen from "../assets/cardsProductos/Lavieen®.webp";
import NEOGENPlasma from "../assets/cardsProductos/NEOGEN Plasma®.webp";
import MELINE from "../assets/cardsProductos/MELINE®.webp";
import Plasmage from "../assets/cardsProductos/Plasmage.webp";
import SylfirmX from "../assets/cardsProductos/Sylfirm X.webp";
import TargetCool from "../assets/cardsProductos/TargetCool®.webp";
// Imagenes de detalle
import RIGENERAEVO_Detail from "../assets/productsDetail/RIGENERAEVO.webp";
import SMARTKER_Detail from "../assets/productsDetail/SMARTKER.webp"
import PBSERUM_HA_Detail from "../assets/productsDetail/pbserumHA.webp";
import PBSERUM_HA_TOTAL_Detail from "../assets/productsDetail/pbserumHATotalCorrector.webp";
import PBSERUM_HA_PARTIAL_Detail from "../assets/productsDetail/pbserumHAPartialCorrector.webp";
import ADVALIGHT_Detail from "../assets/productsDetail/ADVALight.webp";
import BODYSTIM_Detail from "../assets/productsDetail/BodyStimdeBrera.webp";
import CO2LIFT_Detail from "../assets/productsDetail/CO2Lift.webp";
import EMERALD_Detail from "../assets/productsDetail/Emerald.webp";
import FX405_Detail from "../assets/productsDetail/FX405.webp";
import GVL_Detail from "../assets/productsDetail/GVL.webp";
import FINE_Detail from "../assets/productsDetail/ColagenoFINE.webp";
import GOURI_Detail from "../assets/productsDetail/GOURI.webp";
import HYPERPULSE_Detail from "../assets/productsDetail/HyperPulse.webp";
import JALUPRO_Detail from "../assets/productsDetail/JALUPRO.webp";
import JOVENA_Detail from "../assets/productsDetail/JOVENA.webp";
import LAVIEEN_Detail from "../assets/productsDetail/Lavieen.webp";
import NEOGEN_Detail from "../assets/productsDetail/NEOGENPlasma.webp";
import MELINE_Detail from "../assets/productsDetail/MELINE.webp";
import PLASMAGE_Detail from "../assets/productsDetail/Plasmage.webp";
import SYLFIRM_Detail from "../assets/productsDetail/SylfirmX.webp";
import TARGETCOOL_Detail from "../assets/productsDetail/TargetCool.webp";

export const SampleProducts = [
  { 
    id: 1, 
    name: "RIGENERA EVO", 
    category: "Tecnología", 
    brand: "RIGENERA", 
    image: RIGENERAEVO, 
    imageAlt: "RIGENERA-EVO-Holistique", 
    imageDetail: RIGENERAEVO_Detail, 
    subtitle: "Regeneración Celular para una Ortopedia Avanzada.", 
    description: `
      EVO de Regenera Activa AMT representa una nueva generación en terapias regenerativas autólogas. Este innovador equipo médico permite obtener microinjertos del propio paciente de forma rápida, segura y mínimamente invasiva, con alrededor de 70 millones de exosomas.
      
      Gracias a su tecnología avanzada, EVO se aplica con éxito en diferentes áreas de la medicina estética y regenerativa, ofreciendo protocolos personalizados, respaldo científico internacional y los más altos estándares de seguridad.` , 
  },
  {
    id: 2,
    name: "SMARTKER pbserum",
    category: "Insumo",
    brand: "pbserum",
    image: pbserumSMARTKER,
    imageAlt: "SMARTKER-Holistique",
    imageDetail: SMARTKER_Detail,
    subtitle: "Innovación inteligente para una piel radiante.",
    description: `
      Smartker es la primera línea facial inteligente desarrollada con keratinasa, una enzima avanzada que actúa directamente sobre la queratina para mejorar la textura, luminosidad y uniformidad de la piel.

      Diseñada para tratar manchas, opacidad y signos de envejecimiento, Smartker ofrece resultados visibles y seguros gracias a sus protocolos profesionales y su línea Smartker DAILY, ideal para continuar el tratamiento en casa.
      
      Con la combinación perfecta entre ciencia, innovación y cuidado dermatológico, Smartker transforma la piel desde el consultorio hasta la rutina diaria, brindando un rostro más uniforme, saludable y lleno de vitalidad.
    `,
  },
  {
    id: 3,
    name: "pbserum HA",
    category: "Insumo",
    brand: "pbserum",
    image: pbserumHA,
    imageAlt: "pbserum-HA-Holistique",
    imageDetail: PBSERUM_HA_Detail,
    subtitle: "Biotecnología avanzada para resultados visibles y naturales.",
    description: `
      Las enzimas recombinantes PBSerum HA representan una innovación en biotecnología estética, formuladas para tratar diferentes necesidades de la piel con precisión, seguridad y eficacia.
      
      HA Low: Mejora la firmeza y elasticidad, ideal para tratamientos de perfilamiento facial y flacidez.
      HA Medium: Actúa sobre la grasa localizada, especialmente en la zona de la papada.
      HA High: Indicado para fibrosis, heridas y cicatrices complejas, restaurando la calidad y uniformidad de la piel.
      
      Su acción molecular permite resultados progresivos, naturales y mínimamente invasivos, potenciando la salud y belleza de la piel desde su interior.
    `,
  },
  {
    id: 4,
    name: "pbserum HA Total Corrector",
    category: "Insumo",
    brand: "pbserum",
    image: pbserumHATotalCorrector,
    imageAlt: "pbserum-HA-Total-Holistique",
    imageDetail: PBSERUM_HA_TOTAL_Detail,
    subtitle: "Corrección precisa y segura de rellenos con ácido hialurónico.",
    description: `
      pbserum HA Total Corrector es un preparado médico-estético con hialuronidasa, una enzima que disuelve el ácido hialurónico de forma precisa y controlada.
      
      Está indicado para corregir o eliminar rellenos en casos de desplazamiento, exceso de producto o reacciones adversas.
      
      Su acción es rápida y eficaz, con resultados visibles en minutos y eliminación completa en pocas semanas.
      De uso exclusivo para profesionales médicos.
    `,
  },
  {
    id: 5,
    name: "pbserum HA Partial Corrector",
    category: "Insumo",
    brand: "pbserum",
    image: pbserumHAPartialCorrector,
    imageAlt: "pbserum-HA-Partial-Holistique",
    imageDetail: PBSERUM_HA_PARTIAL_Detail,
    subtitle: "Corrección controlada de rellenos de ácido hialurónico.",
    description: `
      PBSerum HA Partial Corrector es un preparado médico-estético con hialuronidasa recombinante, diseñado para ajustar o reducir parcialmente el ácido hialurónico.
      
      Permite correcciones precisas y seguras, logrando resultados visibles sin eliminar totalmente el relleno.
      
      A diferencia del HA Total Corrector, se centra en ajustes moderados para un resultado más armonioso y natural.
    `,
  },
  {
    id: 6,
    name: "ADVALight",
    category: "Tecnología",
    brand: "ADVALight",
    image: ADVALight,
    imageAlt: "ADVALight-Holistique",
    imageDetail: ADVALIGHT_Detail,
    subtitle: "Láser dual para resultados visibles y seguros.",
    description: `
      ADVALight combina 589 nm y 1319 nm para tratar afecciones vasculares, inflamatorias, pigmentarias y de textura de la piel.
      
      Luz amarilla: rosácea, lesiones vasculares, acné activo.
      Infrarrojo: control de sebo, rejuvenecimiento y colágeno.
      
      Resultados visibles, piel más firme y luminosa, sin tiempo de inactividad.
    `,
  },
  {
    id: 7,
    name: "Body Stim de Brera",
    category: "Tecnología",
    brand: "Brera",
    image: BodyStimdeBrera,
    imageAlt: "Body-Stim-Holistique",
    imageDetail: BODYSTIM_Detail,
    subtitle: "Esculpe tu cuerpo de forma natural y efectiva.",
    description: `
      Body Stim redefine la figura sin cirugía ni recuperación prolongada.
      
      Estimula los músculos, activa tonificación, mejora textura y firmeza.
      
      Beneficios: tonificación muscular, estimulación de colágeno, ácido hialurónico y elastina, mejor circulación y tratamiento de celulitis.
    `,
  },
  {
    id: 8,
    name: "CO2Lift®",
    category: "Insumo",
    brand: "CO2Lift",
    image: CO2Lift,
    imageAlt: "CO2Lift-Holistique",
    imageDetail: CO2LIFT_Detail,
    subtitle: "Carboxiterapia tópica para una piel revitalizada.",
    description: `
      Mascarilla con CO₂ estabilizado que oxigena, regenera y reafirma la piel.
      
      Beneficios: mejora textura, tono, estimula colágeno, hidrata y acelera recuperación postprocedimiento.
      
      Apto para rostro, cuello, párpados y zona íntima.
    `,
  },
  {
    id: 9,
    name: "Emerald",
    category: "Tecnología",
    brand: "Erchonia",
    image: Emerald,
    imageAlt: "Emerald-Holistique",
    imageDetail: EMERALD_Detail,
    subtitle: "Reducción de grasa sin contacto ni dolor.",
    description: `
      Tecnología láser fría aprobada por la FDA que elimina grasa corporal sin contacto ni dolor.
      
      Cada sesión de 30 minutos reduce circunferencia corporal y mejora el contorno.
      
      Único láser aprobado para IMC hasta 40%.
    `,
  },
  {
    id: 10,
    name: "FX 405",
    category: "Tecnología",
    brand: "Erchonia",
    image: FX405,
    imageAlt: "FX405-Holistique",
    imageDetail: FX405_Detail,
    subtitle: "Innovación láser para el alivio del dolor y recuperación muscular.",
    description: `
      Tecnología láser de baja intensidad para tratar dolor y acelerar recuperación.
      
      Reduce inflamación, estimula regeneración celular y mejora movilidad.
      
      Aprobado por la FDA, sin efectos secundarios ni medicamentos.
    `,
  },
  {
    id: 11,
    name: "GVL",
    category: "Tecnología",
    brand: "Erchonia",
    image: GVL,
    imageAlt: "GVL-Holistique",
    imageDetail: GVL_Detail,
    subtitle: "Tecnología láser avanzada para salud y bienestar.",
    description: `
      Láser de baja intensidad que reduce inflamación, estimula regeneración celular y acelera curación.
      
      Ideal para lesiones deportivas, dolores crónicos y musculoesqueléticos.
      
      Mejora flujo sanguíneo y bienestar sin cirugía ni inactividad.
    `,
  },
  {
    id: 12,
    name: "Colágeno Fine",
    category: "Insumo",
    brand: "Fine",
    image: ColagenoFINE,
    imageAlt: "Colágeno-Fine-Holistique",
    imageDetail: FINE_Detail,
    subtitle: "Belleza y bienestar desde el interior.",
    description: `
      Suplemento premium de colágeno hidrolizado con ácido hialurónico, vitamina C, zinc y biotina.
      
      Fortalece piel, cabello, uñas y articulaciones.
      
      Resultados: piel más firme, hidratada y luminosa; cabello y uñas fuertes; articulaciones saludables.
    `,
  },
  {
    id: 13,
    name: "GOURI",
    category: "Insumo",
    brand: "Dexlevo",
    image: GOURI,
    imageAlt: "GOURI-Holistique",
    imageDetail: GOURI_Detail,
    subtitle: "La nueva era del rejuvenecimiento inyectable.",
    description: `
      Primera policaprolactona 100% líquida que estimula la producción natural de colágeno.
      
      Tecnología CESABP patentada, segura y sin rellenos.
      
      Resultados naturales, firmeza y luminosidad sin cambios drásticos.
    `,
  },
  {
    id: 14,
    name: "Hyper Pulse",
    category: "Tecnología",
    brand: "Hyper Pulse",
    image: HyperPulse,
    imageAlt: "Hyper-Pulse-Holistique",
    imageDetail: HYPERPULSE_Detail,
    subtitle: "Tecnología de pulsos rápidos para resultados inmediatos.",
    description: `
      Sistema de pulsos de alta velocidad que elimina vello y mejora la piel sin dolor.
      
      Ideal para depilación, rejuvenecimiento, rosácea, melasma y tono uniforme.
    `,
  },
  {
    id: 15,
    name: "JALUPRO®",
    category: "Insumo",
    brand: "JALUPRO",
    image: JALUPRO,
    imageAlt: "JALUPRO-Holistique",
    imageDetail: JALUPRO_Detail,
    subtitle: "Bioestimulación inteligente para una piel firme y radiante.",
    description: `
      Combina ácido hialurónico y aminoácidos esenciales para estimular colágeno y mejorar la calidad de la piel.
      
      Trata líneas finas, pérdida de elasticidad, ojeras y cicatrices.
      
      Resultados naturales y progresivos.
    `,
  },
  {
    id: 16,
    name: "Jovena®",
    category: "Tecnología",
    brand: "Brera Medical",
    image: JOVENA,
    imageAlt: "Jovena-Holistique",
    imageDetail: JOVENA_Detail,
    subtitle: "Tecnología combinada para un rejuvenecimiento integral.",
    description: `
      Combina radiofrecuencia fraccionada y multipolar para mejorar firmeza, textura y flacidez.
      
      Ideal para lifting sin cirugía y rejuvenecimiento íntimo.
    `,
  },
  {
    id: 17,
    name: "Lavieen®",
    category: "Tecnología",
    brand: "Lavieen",
    image: Lavieen,
    imageAlt: "Lavieen-Holistique",
    imageDetail: LAVIEEN_Detail,
    subtitle: "Luminosa como la porcelana, renovada desde la primera sesión.",
    description: `
      Láser fraccional de tulio (1927 nm) que mejora tono, textura y luminosidad con mínima recuperación.
      
      Ideal para manchas, poros dilatados y líneas finas.
    `,
  },
  {
    id: 18,
    name: "NEOGEN Plasma®",
    category: "Tecnología",
    brand: "NEOGEN",
    image: NEOGENPlasma,
    imageAlt: "NEOGEN-Holistique",
    imageDetail: NEOGEN_Detail,
    subtitle: "Regeneración cutánea con ciencia y precisión.",
    description: `
      Utiliza plasma de nitrógeno para regenerar la piel desde sus capas profundas.
      
      Mejora textura, firmeza y luminosidad sin procedimientos invasivos.
    `,
  },
  {
    id: 19,
    name: "MELINE®",
    category: "Insumo",
    brand: "MELINE",
    image: MELINE,
    imageAlt: "MELINE-Holistique",
    imageDetail: MELINE_Detail,
    subtitle: "Soluciones avanzadas para una piel impecable.",
    description: `
      Línea médico-estética especializada en pigmentaciones cutáneas.
      
      Combate manchas, hiperpigmentación y envejecimiento prematuro.
    `,
  },
  {
    id: 20,
    name: "Plasmage",
    category: "Tecnología",
    brand: "BRERA",
    image: Plasmage,
    imageAlt: "Plasmage-Holistique",
    imageDetail: PLASMAGE_Detail,
    subtitle: "Revolucionando la estética sin cirugía.",
    description: `
      Tecnología de plasma que trata arrugas, párpados caídos y cicatrices sin bisturí.
      
      Resultados naturales y rápida recuperación.
    `,
  },
  {
    id: 21,
    name: "Sylfirm X",
    category: "Tecnología",
    brand: "Sylfirm",
    image: SylfirmX,
    imageAlt: "SylfirmX-Holistique",
    imageDetail: SYLFIRM_Detail,
    subtitle: "Innovación en rejuvenecimiento y remodelación de la piel.",
    description: `
      Combina radiofrecuencia y microagujas para mejorar firmeza, reducir manchas y cicatrices con mínima incomodidad.
    `,
  },
  {
    id: 22,
    name: "TargetCool®",
    category: "Tecnología",
    brand: "TargetCool",
    image: TargetCool,
    imageAlt: "TargetCool-Holistique",
    imageDetail: TARGETCOOL_Detail,
    subtitle: "Crioanalgesia precisa para procedimientos cómodos.",
    description: `
      Utiliza CO₂ a alta presión para adormecer la piel y reducir dolor e inflamación.
      
      Ideal para rellenos, toxina botulínica, láseres y zonas sensibles.
    `,
  },
];
